import { FC } from 'react';

import dashboardCampaignSwitcherButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_campaign_switcher_button_click';
import { Switch } from '@hh.ru/magritte-ui';

import { useCampaignSwitchChecked } from 'components/CampaignsDashboard/hooks/useCampaignSwitchChecked';

import { getIsMutatingActionAvailable } from 'components/CampaignsDashboard/utils/utils';

import { DashboardCampaign } from 'store/models/campaignsDashboard';
import { currentAccount } from 'store/models/user';
import { useSelector } from 'store/utils';

export const CampaignSwitch: FC<{
    campaign: DashboardCampaign;
    isStatusToggleLoading: boolean;
    onToggleStatus: () => void;
}> = ({ campaign, isStatusToggleLoading, onToggleStatus }) => {
    const currentAccountStatus = useSelector(currentAccount)?.status;

    const { id: campaignId, frontendStatus } = campaign;
    const isMutatingActionAvailable = getIsMutatingActionAvailable(frontendStatus, currentAccountStatus);

    const isSwitchChecked = useCampaignSwitchChecked(campaign, isStatusToggleLoading);

    const handleClick = () => {
        dashboardCampaignSwitcherButtonClick({ activeStatus: frontendStatus, campaignId });
        onToggleStatus();
    };

    return (
        <Switch
            checked={isSwitchChecked}
            disabled={!isMutatingActionAvailable}
            data-qa={`campaigns-table-switch-${campaignId}`}
            onClick={handleClick}
        />
    );
};
